'use client'
import * as S from './projects.style'
import { Project } from '../types'
import { UIText } from '@/component-library'

export const Projects: React.FC<{ title: string; projects: Project[] }> = ({ title, projects }) => {
  return (
    <S.Container>
      <h2>{title}</h2>
      <>
        {projects.map(({ title, description, icon, category }, i) => (
          <Item key={title} title={title} content={description} icon={icon} />
        ))}
      </>
    </S.Container>
  )
}

const Item = ({
  title,
  content,
  icon,
}: {
  title: string
  content: string | number | undefined
  icon: { url: string }
}) => {
  return (
    <S.Item>
      <picture role="icon">
        <img alt="" width="40" src={icon.url} />
      </picture>
      <UIText as="h4">{title}</UIText>
      {content && <UIText>{content}</UIText>}
    </S.Item>
  )
}
